import { Markdown } from './Markdown';
import { OpenAPIEmptyExample, OpenAPIExample } from './OpenAPIExample';
import { OpenAPIMediaTypeContent } from './OpenAPIMediaType';
import { OpenAPIResponseExampleContent } from './OpenAPIResponseExampleContent';
import { getOpenAPIClientContext } from './context';
import { getExampleFromReference, getExamples } from './util/example';
import { createStateKey, getStatusCodeDefaultLabel } from './utils';
import { checkIsReference, resolveDescription } from './utils';
/**
 * Display an example of the response content.
 */
export function OpenAPIResponseExample(props) {
    var data = props.data, context = props.context;
    // if there are no responses defined for the operation
    if (!data.operation.responses) {
        return null;
    }
    var responses = Object.entries(data.operation.responses);
    // Sort response to get 200, and 2xx first
    responses.sort(function (_a, _b) {
        var a = _a[0];
        var b = _b[0];
        if (a === 'default') {
            return 1;
        }
        if (b === 'default') {
            return -1;
        }
        if (a === '200') {
            return -1;
        }
        if (b === '200') {
            return 1;
        }
        return Number(a) - Number(b);
    });
    var tabs = responses.map(function (_a) {
        var key = _a[0], responseObject = _a[1];
        var description = resolveDescription(responseObject);
        var label = description ? (<Markdown source={description}/>) : (getStatusCodeDefaultLabel(key, context));
        if (checkIsReference(responseObject)) {
            return {
                key: key,
                label: label,
                statusCode: key,
                body: (<OpenAPIExample example={getExampleFromReference(responseObject, context)} context={context} syntax="json"/>),
            };
        }
        if (!responseObject.content || Object.keys(responseObject.content).length === 0) {
            return {
                key: key,
                label: label,
                statusCode: key,
                body: <OpenAPIEmptyExample context={context}/>,
            };
        }
        return {
            key: key,
            label: label,
            statusCode: key,
            body: <OpenAPIResponse context={context} content={responseObject.content}/>,
        };
    });
    if (tabs.length === 0) {
        return null;
    }
    return (<OpenAPIResponseExampleContent selectIcon={context.icons.chevronDown} blockKey={context.blockKey} items={tabs}/>);
}
function OpenAPIResponse(props) {
    var context = props.context, content = props.content;
    var entries = Object.entries(content);
    var firstEntry = entries[0];
    if (!firstEntry) {
        throw new Error('One media type is required');
    }
    var tabs = entries.map(function (entry) {
        var mediaType = entry[0], mediaTypeObject = entry[1];
        return {
            key: mediaType,
            label: mediaType,
            body: <></>,
            examples: getExamples({
                mediaTypeObject: mediaTypeObject,
                mediaType: mediaType,
                context: context,
            }),
        };
    });
    return (<OpenAPIMediaTypeContent selectIcon={context.icons.chevronDown} stateKey={createStateKey('response-media-types', context.blockKey)} items={tabs} context={getOpenAPIClientContext(context)}/>);
}
